import AuthService from './authService';
import OutsourcedFeeItem from '../Domain/OutsourcedFeeItem';
import SearchParams from '../Elements/SearchParams';
import OutsourcedFeeSearchParams from '../Contents/OutsourcedInvoicing/OutsourcedFee/OutsourcedFeeSearchParams';

export default class OutsourcedFeeService {
  static GetList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      OutsourcedFeeSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/OutsourcedFee/GetList/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    if (items === null) return [];
    return items.map((item) => new OutsourcedFeeItem(item));
  }

  static Upsert(editedItem) {
    editedItem.SurveyId = editedItem.SurveyId?.split('//')[0] ?? null;
    editedItem.TpSurveyId = editedItem.TpSurveyId?.split('//')[0] ?? null;
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedFee/Upsert', editedItem);
  }

  static Close(editedItem) {
    return AuthService.getInstance().CallBackendFunctionPost(`/api/OutsourcedFee/Close`, editedItem);
  }
}
